import { render, staticRenderFns } from "./WhatsNewScrolling.vue?vue&type=template&id=e9b41cee&scoped=true&"
import script from "./WhatsNewScrolling.vue?vue&type=script&lang=js&"
export * from "./WhatsNewScrolling.vue?vue&type=script&lang=js&"
import style0 from "./WhatsNewScrolling.vue?vue&type=style&index=0&id=e9b41cee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b41cee",
  null
  
)

export default component.exports